export const validateCashFields = (value) => {
  // Regular expression to allow only numbers and up to two decimal places
  const regex = /^\d*\.?\d{0,2}$/;

  // Check if the input matches the regex
  if (regex.test(value)) {
    return value; // Return the valid value
  }

  // If the value doesn't match, return an empty string or the last valid value
  return null;
};
